import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo: string;
  requireAuth?: boolean;
}

/**
 * Composant qui protège une route en redirigeant selon l'état d'authentification
 * @param children - Le composant à rendre si les conditions sont remplies
 * @param redirectTo - L'URL vers laquelle rediriger si les conditions ne sont pas remplies
 * @param requireAuth - Si true, redirige si l'utilisateur n'est PAS authentifié. Si false, redirige si l'utilisateur EST authentifié
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo,
  requireAuth = true,
}) => {
  const { isAuthenticated, loading } = useAuth();

  // Attendre que l'état d'authentification soit chargé
  if (loading) {
    return null; // ou un spinner de chargement
  }

  // Si requireAuth est true et l'utilisateur n'est pas authentifié, rediriger
  if (requireAuth && !isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Si requireAuth est false et l'utilisateur est authentifié, rediriger
  if (!requireAuth && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
